/** Shown when the contact form cannot be delivered. Never include an address. */
export const CONTACT_SEND_FAILURE =
  "Something went wrong sending your message. Please try again later.";
